export default __webpack_public_path__ + "static/media/=AFISHA FR.tif - Copy.248c14e0.jpg";